import React from "react";
import { TextField, Typography } from "@mui/material";

export default function NCRMultilineTextfields({
  name,
  value,
  onChange,
  disabled,
  placeholder = "Enter text",
  error
}) {
  const isLimitExceeded = value.length > 250;

  const preventInvalidSpaces = (e) => {
    const { value, selectionStart } = e.target;

    if (e.key === " " && selectionStart === 0) {
      e.preventDefault();
      return;
    }

    if (e.key === " " && value[selectionStart - 1] === " ") {
      e.preventDefault();
    }
  };
  const sanitizeOnInput = (e) => {
    const cleaned = e.target.value
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/g, "")
      .replace(/\s+$/g, "");

    if (e.target.value !== cleaned) {
      e.target.value = cleaned;
      e.target.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };

  return (
    <>
      <TextField
        multiline
        minRows={3}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        value={value || ""}
        disabled={disabled}
        error={error || isLimitExceeded}
        inputProps={{
          onKeyDown: preventInvalidSpaces,
          onBlur: sanitizeOnInput,
        }}
        sx={{
          fontFamily: 'Lato, sans-serif',
          width: "563px",
          maxWidth: "100%",
          backgroundColor: "transparent",
          "&.Mui-disabled": {
            backgroundColor: "rgba(235, 235, 235, 1)",
            border: "1px solid rgba(0, 0, 0, 0.23)",
          },
        }}
      />
      {!disabled && isLimitExceeded && (
        <Typography
          sx={{
            fontSize: "11px",
            color: "#d32f2f",
          }}
        >
          Allowed only max 250 characters
        </Typography>
      )}

    </>
  );
}
